import { useCallback } from 'react';
import { useAtom } from 'jotai';
import { useOperatorMenuVisibility } from '@ibk/shared-permissioning';
import { OperatorDrawerNavs } from '@ibk/shared-types';
import { operatorDrawerAtom, operatorDrawerErrorAtom, operatorDrawerModalPasswordAuthenticationVisibleAtom, operatorDrawerNavigationAtom, operatorDrawerSuccessAtom, } from '@ibk/shared-utils';
export const useDrawerOperator = () => {
    const [operatorDrawerVisible, setOperatorDrawerVisible] = useAtom(operatorDrawerAtom);
    const [operatorDrawerCurrentRoute, setOperatorDrawerCurrentRoute] = useAtom(operatorDrawerNavigationAtom);
    const [operatorDrawerAuthenticateVisible, setOperatorDrawerAuthenticateVisible] = useAtom(operatorDrawerModalPasswordAuthenticationVisibleAtom);
    const [operatorDrawerError, setOperatorDrawerError] = useAtom(operatorDrawerErrorAtom);
    const [operatorDrawerSuccess, setOperatorDrawerSuccess] = useAtom(operatorDrawerSuccessAtom);
    const canSeeDrawer = useOperatorMenuVisibility();
    const handleCloseOperatorDrawerError = () => {
        setOperatorDrawerError(undefined);
    };
    const handleCloseOperatorDrawerSuccess = () => {
        setOperatorDrawerSuccess(undefined);
    };
    const handleOpenDrawer = useCallback(() => {
        setOperatorDrawerVisible(true);
    }, [setOperatorDrawerVisible]);
    const handleCloseDrawer = useCallback(() => {
        if (!operatorDrawerError && !operatorDrawerSuccess) {
            setOperatorDrawerVisible(false);
            setOperatorDrawerCurrentRoute('clear');
        }
    }, [operatorDrawerError, operatorDrawerSuccess, setOperatorDrawerVisible, setOperatorDrawerCurrentRoute]);
    const handleGoBack = useCallback(() => {
        if (operatorDrawerCurrentRoute.route === OperatorDrawerNavs.HOME) {
            handleCloseDrawer();
            return;
        }
        setOperatorDrawerCurrentRoute('goBack');
    }, [handleCloseDrawer, operatorDrawerCurrentRoute, setOperatorDrawerCurrentRoute]);
    const handleGoTo = useCallback((route, params) => {
        if (params) {
            setOperatorDrawerCurrentRoute(route, params);
            return;
        }
        setOperatorDrawerCurrentRoute(route);
    }, [setOperatorDrawerCurrentRoute]);
    const handleCloseAuthModal = useCallback(() => {
        setOperatorDrawerAuthenticateVisible(false);
    }, [setOperatorDrawerAuthenticateVisible]);
    const states = {
        canSeeDrawer,
        operatorDrawerAuthenticateVisible,
        operatorDrawerVisible,
        operatorDrawerCurrentRoute,
        operatorDrawerError,
        operatorDrawerSuccess,
    };
    const actions = {
        handleGoBack,
        handleGoTo,
        handleOpenDrawer,
        handleCloseDrawer,
        handleCloseAuthModal,
        handleCloseOperatorDrawerError,
        handleCloseOperatorDrawerSuccess,
    };
    return {
        states,
        actions,
    };
};
